
let bc

const create = () => {
  if (!!bc) return bc

  bc = new window.BroadcastChannel("cds")

  return bc
}

const sendMessage = (data) => {
  if (!bc) return

  bc.postMessage(data)
}

const get = () => bc

const cdsBroadcastChannel = {
  create,
  sendMessage,
  get
}

export default cdsBroadcastChannel